import { apiRequest } from "./apiClient";

/**
 * Per-user map bookmarks (backend: /bookmarks, cookie-authenticated).
 * Listing is paged: { items, page, page_size, total, pages }.
 */
export async function listBookmarks({ page = 1, pageSize = 10, name = null } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (name) params.set("name", name);
  return apiRequest(`/bookmarks?${params}`);
}

/** @param {{name:string, center_lon:number, center_lat:number, zoom:number}} data */
export async function createBookmark(data) {
  return apiRequest("/bookmarks", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function deleteBookmark(bookmarkId) {
  return apiRequest(`/bookmarks/${bookmarkId}`, { method: "DELETE" });
}
